export function muxVideoUrl(videoId: string | undefined): string | undefined {
  if (!videoId) return undefined;
  return `https://stream.mux.com/${videoId}.m3u8`;
}

export function muxPosterUrl(
  videoId: string | undefined,
  time: number = 0
): string | undefined {
  if (!videoId) return undefined;
  return `https://image.mux.com/${videoId}/thumbnail.png?time=${time}&fit_mode=preserve`;
}
